/* eslint-disable  */

import React, { useEffect, useState } from 'react';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { CORRECTIVE_GRID_HTML_ID } from 'constants/grid/grid';
import { CORRECTIVES } from 'constants/grid/names';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { useDispatchFilter, useSelectFilter } from 'hooks/planning/useFilter';
import { useDispatchGrid, useGridData } from 'hooks/grid/useDailyBulletinGrid';
import { IFilterOptions } from 'interfaces/SelectOptions';
import { useInfiniteQuery, useQuery } from 'react-query';
import { getInstallationFilter } from 'services/installation';
import ModalNewBulletim from 'components/molecules/DailyBulletinGrid/components/ModalNewBolletim';
import { Hide } from 'components';
import { GROUPS } from 'constants/permissions';
import { Grid, Button } from '@material-ui/core';
import FilterBarItem from 'components/molecules/FilterBarItem';

import DateDayjstUtils from '@date-io/dayjs';
import dayjs from 'dayjs';
import { useAuth } from 'hooks/useAuth';
import ptBR from 'dayjs/locale/pt-br';
import useStyles from './style';
import { postExecutorBulletinFilter } from 'services/executor';
import { IEquipmentFilterData } from 'interfaces/Equipment';
import qs from 'qs';
import { debounce } from 'lodash';
import { GridProvider } from 'hooks/grid/useEquipmentGrid';
import InfoTurbinesOperation from 'components/molecules/InfoTurbinesOperation';
import { IInfoTurbinesOperation } from 'interfaces/Grid';

const TAKE = 10;
const TAKE100 = 100;
const DailyBulletinTopContainer = () => {
  const classes = useStyles();

  const { checkPermissions } = useAuth();

  const [openModal, setOpenModal] = React.useState<boolean>(false);

  const changeFilter = useDispatchFilter();

  const correctives = useGridData(CORRECTIVES);
  const changeGrid = useDispatchGrid(CORRECTIVES);
  const [valueGrid, setValueGrid] = React.useState<any[]>([]);

  const [inputFieldValues, setInputFieldValues] = React.useState<{
    [key: string]: string;
  }>({});

  const [filterInstallationOptions, setFilterInstallationOptions] =
    React.useState<IFilterOptions[]>([]);

  const [
    installationFilterOptionsContext,
    selectedDateOptionContext,
    supplierFilterOptionsContext,
  ] = [
    useSelectFilter('installation'),
    useSelectFilter('date'),
    useSelectFilter('supplier'),
  ];

  const valueStateSelect = installationFilterOptionsContext.map(item => ({
    label: item.label,
    id: item.value,
    code: item.code,
  }));

  const valueToGrid = valueGrid.map(item => ({
    equipmentCode: item.code,
    equipmentDescription: item.label,
    installation: item.value,
    installationId: item.value,
  }));

  const allFilterContexts = [
    installationFilterOptionsContext,
    supplierFilterOptionsContext,
  ];

  const [filterSupplierOptions, setFilterSupplierOptions] = React.useState<
    IFilterOptions[]
  >([]);

  const installationIds = installationFilterOptionsContext.map(item =>
    +item?.value,
  );
  
  const pauseFilterInstallation = React.useMemo<boolean>(() => {
    return installationFilterOptionsContext.length > 0;
  }, [installationFilterOptionsContext]);

  const queryFilterInstallation = useQuery({
    queryKey: ['installationFilterOptionsContext'],
    queryFn: async () => {
      const { data } = await getInstallationFilter();
      return data;
    },
    select: data => {
      return data.map(item => {
        return {
          label: item.description,
          value: item.id,
          code: item.code,
        };
      });
    },
    onSuccess: (data: IFilterOptions[]) => {
      setFilterInstallationOptions(data);
      setValueGrid(data);
    },
    enabled: !pauseFilterInstallation,
  });

  const queryFilterSupplier = useInfiniteQuery({
    queryKey: [
      'equipmentSupplierOptionsContext',
      [...allFilterContexts, inputFieldValues?.supplier],
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const qsparams = {
        page: pageParam,
        take: TAKE100,
      } as { page: number; take: number };

      const params = {
        installationIds,
      } as { [key: string]: (string | number)[] | string | number };

      if (
        inputFieldValues?.supplier &&
        inputFieldValues?.supplier.length >= 2
      ) {
        params.descriptionFilter = inputFieldValues?.supplier;
      }

      const { data } = await postExecutorBulletinFilter(qs.stringify(qsparams), params);
      return data;
    },
    getNextPageParam: (
      lastPage: IEquipmentFilterData,
      allPages: IEquipmentFilterData[],
    ) => {
      const allResults = allPages.map(page => page.result).flat().length;
      if (allResults === 0) return 1;

      const hasNextPage = allResults < lastPage.count;
      if (hasNextPage) return allResults / TAKE + 1;

      return undefined;
    },
    onSuccess: data => {
      const options = data?.pages
        .map(item => item.result)
        .flat()
        .map(item => ({
          label: item.description,
          value: item.id,
        }));
      setFilterSupplierOptions(options);
    },
    cacheTime: 0,
  });

  const handleChange = ({
    name,
    value,
  }: {
    name: string;
    value: IFilterOptions[];
  }) => {
    changeFilter(name, value);
  };

  const textMessageCorrectivesCounter = React.useMemo((): string => {
    if (correctives?.numberOfCorrectives === 1) {
      return `${correctives?.numberOfCorrectives} Item de GC`;
    }

    if (correctives?.numberOfCorrectives) {
      return `${correctives?.numberOfCorrectives} Itens de GC`;
    }

    return '';
  }, [correctives]);

  const navigateToCorrectivesAndOpenIt = React.useCallback(
    event => {
      changeGrid({
        ...correctives,
        open: true,
      });

      const anchor = (event.target.ownerDocument || document).querySelector(
        `#${CORRECTIVE_GRID_HTML_ID}`,
      );

      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    [changeGrid, correctives],
  );
  const [turb, setTurb] =  useState<any>([]);
  const [turbineParameter, setTurbineParameter] =
    useState<IInfoTurbinesOperation>({
      installationIds: [],
      supplierExecutors: [],
      date: selectedDateOptionContext[0]?.value,
      areaType: '',
      type: '',
      order: [],
    });


    useEffect(() => {
      changeTurbineOperation();
    }, [installationFilterOptionsContext, selectedDateOptionContext]);


  function changeTurbineOperation() {
      setTurbineParameter({
        installationIds: installationIds,
        supplierExecutors: [],
        date: selectedDateOptionContext[0]?.value,
        areaType: '',
        type: '',
        order: [],
      });
  }

  return (
    <div className={classes.root}>
      <Grid container justifyContent="space-between" spacing={1}>
        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <MuiPickersUtilsProvider locale={ptBR} utils={DateDayjstUtils}>
                <KeyboardDatePicker
                  value={selectedDateOptionContext[0].value}
                  onChange={date => {
                    if (dayjs(date).isValid())
                      handleChange({
                        name: 'date',
                        value: [
                          {
                            label: date?.toISOString() || '',
                            value: date?.toISOString() || '',
                          },
                        ],
                      });
                  }}
                  inputVariant="outlined"
                  label="Data"
                  cancelLabel="Cancelar"
                  format="DD/MM/YYYY"
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={3}>
              <FilterBarItem
                id="installation"
                label="Instalação"
                name="installation"
                options={filterInstallationOptions}
                onFilterChange={handleChange}
                loading={queryFilterInstallation?.isLoading}
                initialState={[]}
              />
            </Grid>

            <Grid item xs={3}>
              <FilterBarItem
                id="supplier-filter"
                label="Empresa"
                name="supplier"
                options={filterSupplierOptions}
                onFilterChange={handleChange}
                fetchNextPage={queryFilterSupplier.fetchNextPage}
                loading={
                  queryFilterSupplier.isLoading ||
                  queryFilterSupplier?.isFetching
                }
                initialState={[]}
              />
            </Grid>

            {/* <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            > */}
            <ModalNewBulletim
              css={{ cursor: 'pointer' }}
              open={openModal}
              onClose={() => {
                setOpenModal(false);
              }}
              values={valueStateSelect}
              valueToGrid={valueToGrid}
            >
              <Button
                color="primary"
                disabled={valueStateSelect.length !== 1}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Cadastrar
              </Button>
            </ModalNewBulletim>
            {/* </Hide> */}
          </Grid>
        </Grid>


        <Grid item xs={4}>
          <InfoTurbinesOperation turbineData={turbineParameter} />
        </Grid>

        <Grid item xs={2}>
          {Boolean(textMessageCorrectivesCounter) && (
            <Grid container justifyContent="flex-end">
              <Button
                startIcon={<NotificationsActiveIcon />}
                variant="contained"
                color="secondary"
               
                // onClick={navigateToCorrectivesAndOpenIt}
              >
                {textMessageCorrectivesCounter}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default DailyBulletinTopContainer;
